import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from '../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-daily-heralds',
  templateUrl: './daily-heralds.component.html',
  styleUrls: ['./daily-heralds.component.css']
})
export class DailyHeraldsComponent implements OnInit {
  loading = false
  eventArr = []
  objArr = []
  pageSize
  totalItems
  pageNo
  arr = [1, 2, 3, 4, 5]
  constructor(private authService: AuthservicesService, private router: Router) {

    this.pageSize = 10

  }
  ngOnInit(): void {

    this.getAlerts(1);
  }


  getAlerts(event) {
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.authService.getPostCards(skip, this.pageSize, true).subscribe((res: any) => {
      this.loading = true
      this.eventArr = res.items
      this.totalItems = res.total

      this.eventArr.forEach((e) => {
        this.objArr.push({
          id: (e._id) ? e._id : '',
          name: (e.name) ? e.name : '',
          description: (e.description) ? e.description : '',
          createdBy: (e.createdBy) ? e.createdBy : '',
        })
      })
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }
}
